import comp from "./AISpeechToText";
export default comp;
